import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSpacebar: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="spacebar"><path d="M2.75 13V19.25H21.25V13" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconSpacebar;
